import React, { useEffect, useState } from "react";
import axios from "axios";
import "../ShareProduct/ShareProduct.css";
import { Api } from "../../../Admin/BackendApi/api";
import { useNavigate } from "react-router-dom";
import SearchBar from "../../Component/SearchBar/SerachBar";
import { FaSortAmountDown } from "react-icons/fa";
import SortModal from "../../Component/SortModal/SortModal";
import { APP_VERSION } from "../../../Admin/Pages/Version Provider/VersionConfig";
import ConfirmPopup from "../../../Admin/Component/ConfirmPopup/ConfirmPopup";

const ShareProduct = () => {
    const [products, setProducts] = useState([]);
    const [search, setSearch] = useState("");
    const [loading, setLoading] = useState(false);

    const [sortColumn, setSortColumn] = useState("ProductName");
    const [sortOrder, setSortOrder] = useState(-1);

    const [isSortOpen, setIsSortOpen] = useState(false);

    const [versionCode] = useState(APP_VERSION);

    const [popup, setPopup] = useState({
        show: false,
        message: "",
        type: "error",
    });

    const navigate = useNavigate();

    const handlePopupClose = () => {
        setPopup({ ...popup, show: false });
    };

    const fetchProducts = async (searchValue = "") => {
        try {
            setLoading(true);

            const token = localStorage.getItem("token");

            if (!token) {
                navigate("/user/login");
                return;
            }

            const response = await axios.post(
                Api.getuserproduct,
                {
                    VersionCode: versionCode,
                    search_product: searchValue,
                    sort_column: sortColumn,
                    sort_order: sortOrder,
                },
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                },
            );

            if (response.data.status === 0) {
                setPopup({
                    show: true,
                    message: (
                        <>
                            <span style={{ fontSize: "20px" }}>❌</span>{" "}
                            {response.data.message}
                        </>
                    ),
                    type: "error",
                });

                setLoading(false);
                return;
            }

            const result = response.data.data;

            if (Array.isArray(result)) {
                setProducts(result);
            } else if (result) {
                setProducts([result]);
            } else {
                setProducts([]);
            }
        } catch (error) {
            if (error.response && error.response.status === 401) {
                localStorage.removeItem("token");
                navigate("/user/login");
            } else {
                setPopup({
                    show: true,
                    message: "Server error. Try again.",
                    type: "error",
                });

                console.error(
                    "API Error:",
                    error.response?.data || error.message,
                );
            }
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        const delayDebounce = setTimeout(() => {
            fetchProducts(search);
        }, 300);

        return () => clearTimeout(delayDebounce);
    }, [search, sortColumn, sortOrder]);

    return (
        <div className="user-product-container">
            <div className="user-product-frame">
                <div
                    className="user-product-header"
                    style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        gap: "10px",
                    }}
                >
                    <SearchBar
                        search={search}
                        setSearch={setSearch}
                        onSearchClick={() => fetchProducts(search)}
                    />

                    <div
                        onClick={() => setIsSortOpen(true)}
                        style={{
                            backgroundColor: "#704A94",
                            padding: "8px",
                            borderRadius: "6px",
                            cursor: "pointer",
                            marginBottom: "10px",
                        }}
                    >
                        <FaSortAmountDown color="white" />
                    </div>
                </div>

                <SortModal
                    isOpen={isSortOpen}
                    onClose={() => setIsSortOpen(false)}
                    onApply={(col, order) => {
                        setSortColumn(col);
                        setSortOrder(order === "asc" ? 1 : -1);
                    }}
                    currentColumn={sortColumn}
                    currentOrder={sortOrder === 1 ? "asc" : "desc"}
                    columns={[
                        { label: "Name", value: "ProductName" },
                        { label: "Price", value: "ProductSellingPrice" },
                        { label: "Coins", value: "AllotCoins" },
                    ]}
                />

                <div className="user-product-list-scroll">
                    <div className="user-product-list">
                        {loading ? (
                            <div className="spinner-container">
                                <div className="spinner"></div>
                            </div>
                        ) : products.length === 0 ? (
                            <p>No products found</p>
                        ) : (
                            products.map((p) => (
                                <div key={p._id} className="user-product-card">
                                    <div className="user-product-top">
                                        <div className="user-left-side">
                                            <div className="user-product-img">
                                                IMG
                                            </div>
                                        </div>

                                        <div className="user-product-info">
                                            <h3>{p.ProductName}</h3>
                                            <h4 className="user-coins green">
                                                +{p.AllotCoins} coins
                                            </h4>
                                        </div>

                                        <div className="user-product-price">
                                            <span className="user-product-mrp">
                                                ₹{p.ProductMRP}
                                            </span>
                                            <span className="user-product-selling-price">
                                                ₹{p.ProductSellingPrice}
                                            </span>
                                        </div>
                                    </div>

                                    <div className="user-product-card-footer">
                                        <p className="user-category">
                                            Status: {p.Status}
                                        </p>
                                        <p className="user-desc">
                                            {p.Description}
                                        </p>
                                    </div>
                                </div>
                            ))
                        )}
                    </div>
                </div>
            </div>

            <ConfirmPopup
                show={popup.show}
                message={popup.message}
                type={popup.type}
                onClose={handlePopupClose}
            />
        </div>
    );
};

export default ShareProduct;
